export * from './get-common-component-color';
export * from './get-compoment-classes';
export * from './get-component-property';
export * from './get-text-size';
